import {
  Container,
  Box,
  Modal,
  Button,
  Grid,
  Checkbox,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
  ButtonGroup,
  Stack,
  TextField,
  FormControl,
  FormHelperText,
  FormLabel,
  IconButton,
  Typography,
  Autocomplete,
  Select,
} from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { TableFilters } from "../../components/shared/data-table/TableFilters";
import { useEffect, useState } from "react";
import { InputText } from "../../components/shared/form/InputText";
import {} from "@mui/material";
import {
  setFilter,
  applyFilter,
  resetExternalFilter,
  filterFlagChange,
  setDocumentProcessingFromDate,
  setDocumentProcessingToDate,
  setInvoiceSummaryFromDate,
  setInvoiceSummaryToDate,
  filterResetFlagChange,
  setInvoiceEndDate,
} from "../../store/slices/externalFilter";
import { useDispatch, useSelector } from "react-redux";
import * as React from "react";
import moment from "moment";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import BreadcrumbNavs from "../../components/shared/breadcrumbs/Breadcrumbs";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import { ThreeStateCheckbox } from "../../components/shared/form/ThreeStateCheckbox";
import {
  warningModal,
  handleAddEditModal,
  handleUserDisputeModal,
  releaseSystemDisputeModal,
  handleModalState,
} from "../../store/slices/modals";
import WarningModal from "../../components/shared/modals/WarningModal";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from "@mui/icons-material/Circle";
import {
  setRowPage,
  resetDataGrid,
  setPageNo,
} from "../../store/slices/dataGrid";
import { useLayoutEffect } from "react";
import { styled } from "@mui/material/styles";
import { hasTabEdit } from "../../store/slices/generalProduct";
import { setSelectedRow } from "../../store/slices/invoiceViewDetails";
import { AutoCompleteStatic } from "../../components/shared/form/AutoCompleteStatic";
import axiosMember from "../../services/utility/axios-member";
import InvoiceDetails from "./detailInvoices/InvoiceDetails";
import LinesandDiscountsTab from "./detailInvoices/invoice-details-tabs/lines-discounts";
import LineDisputeLogTab from "./detailInvoices/invoice-details-tabs/line-dispute-log";
import SelectedInvoiceTab from "./detailInvoices/invoice-details-tabs/selected-invoice";
import SnackBarDialog from "../../components/shared/SnackBarDialog";
import UserDisputeModal from "./disputes/UserDisputeModal";
import { releaseSystemDisputeStatus } from "../../store/slices/invoiceDisputes";
import {
  smaInput,
  setMemberCode,
} from "../../store/slices/supplierMemberAccounts";
import axiosInvoiceSummaries from "../../services/utility/axios-invoice-summaries";
import PageLoader from "../../components/shared/PageLoader";
import CommonPopUp from "../products/addEditPdc/pdc-tabs/CommonPopUp";
import UploadInvoiceModal from "./UploadInvoiceModal";
import { DataTableDocumentProcessing } from "../../components/shared/data-table/DataTableDocumentProcessing";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import RefreshIcon from "@mui/icons-material/Refresh";
import { SelectDropDown } from "../../components/shared/form/Select";
import { CircularProgress } from "@material-ui/core";
import axiosDocumentProcessing from "../../services/utility/axios-document-processing";
import EditViewDocumentProcess from "./editViewDocumentProcess/editViewDocumentProcess";
import {
  fetchDocumentById,
  clearValidationErrors,
  clearDocument,
} from "../../store/slices/documentProcessingSlice";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";

var disputeflag = "default";
var selected_row = null;

const Item = styled(Paper)(({ theme }) => ({
  paddingLeft: theme.spacing(0),
  paddingRight: theme.spacing(1.5),
  boxShadow: "none",
  background: "none",
}));

// const IconMenuLink = ({ params }) => {
//   const { row } = params;
//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);

//   const {
//     showAddEditModal,
//     docpro_container,
//     invoiceSummary_fields,
//     invoiceDetailsRow,
//     showUserDisputeModal,
//     releaseSysDispute,
//   } = useSelector((state) => {
//     return {
//       showAddEditModal: state.modalActions.hideAddEditModal,
//       docpro_container: state.docProVal,
//       editTabData: state.invoiceSummarys.editTabData,
//       invoiceSummary_fields: state.invoiceSummarys,
//       invoiceDetailsRow: state.invoiceViewDetails,
//       showUserDisputeModal: state.modalActions.hideUserDisputeModal,
//       releaseSysDispute: state.modalActions.releaseSystemDispute,
//     };
//   });
//   const dispatch = useDispatch();

//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };
//   const handleClose = (event, action) => {
//     event.preventDefault();
//     if (action === "view_more") {
//       dispatch(
//         handleAddEditModal({
//           showAddEdit: !showAddEditModal,
//         })
//       );
//       dispatch(hasTabEdit({ editTab: false })); // For showing 3 tabs inside the View More Modal
//       // selectedvals = row;
//       dispatch(setSelectedRow({ selectedrow: row }));
//     }
//     if (action === "edit") {
//       dispatch(
//         handleAddEditModal({
//           showAddEdit: !showAddEditModal,
//         })
//       );
//       dispatch(hasTabEdit({ editTab: true })); // For showing 3 tabs inside the View More Modal
//       // selectedvals = row;
//       dispatch(setSelectedRow({ selectedrow: row }));
//     }
//     if (action === "release_system_dispute") {
//       selected_row = row;
//       dispatch(
//         releaseSystemDisputeStatus({
//           key: "startReleaseSystemDispute",
//           value: true,
//         })
//       );
//       dispatch(
//         releaseSystemDisputeModal({
//           releasesystemdispute: !releaseSysDispute,
//         })
//       );
//     }
//     if (action === "set_user_dispute") {
//       selected_row = row;
//       disputeflag = "setuserdispute";
//       dispatch(
//         handleUserDisputeModal({
//           showAddEditUserDispute: !showUserDisputeModal,
//         })
//       );
//     }
//     if (action === "release_user_dispute") {
//       selected_row = row;
//       disputeflag = "releaseuserdispute";
//       dispatch(
//         handleUserDisputeModal({
//           showAddEditUserDispute: !showUserDisputeModal,
//         })
//       );
//     }
//     setAnchorEl(null);
//   };

//   return (
//     <>
//       <IconButton
//         aria-label="more"
//         aria-controls={open ? "long-menu" : undefined}
//         aria-expanded={open ? "true" : undefined}
//         aria-haspopup="true"
//         onClick={handleClick}
//         id={row.id + 1}
//       >
//         <MoreVertIcon />
//       </IconButton>
//       <Menu
//         id={row.id}
//         anchorEl={anchorEl}
//         open={open}
//         onClose={handleClose}
//         MenuListProps={{
//           "aria-labelledby": "basic-button",
//         }}
//         className="actionMenuBx"
//       >
//         {/* <MenuItem onClick={(e) => handleClose(e, "view_more")}>
//           View More
//         </MenuItem>
//         <MenuItem
//           disabled={row.systemDisputed === false ? true : false}
//           onClick={(e) => handleClose(e, "release_system_dispute")}
//         >
//           Release System Dispute
//         </MenuItem> */}
//         {row.status !== "PASS" ? (
//           <MenuItem onClick={(e) => handleClose(e, "edit")}>
//             Edit
//           </MenuItem>
//         ) : (
//           <MenuItem onClick={(e) => handleClose(e, "view_more")}>
//             View
//           </MenuItem>
//         )}
//       </Menu>
//     </>
//   );
// };
const IconMenuLink = ({ params }) => {
  const { row } = params;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();

  const { showAddEditModal } = useSelector((state) => ({
    showAddEditModal: state.modalActions.hideAddEditModal,
  }));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOpenModal = (event) => {
    event.preventDefault();

    // Dispatch the thunk to fetch the full document details using its ID.
    // The slice will handle the loading state, and the modal will automatically
    // display the data once the fetch is successful.
    dispatch(clearValidationErrors()); // This is just cleanup
    dispatch(clearDocument()); // This is just cleanup
    dispatch(fetchDocumentById(row.id));

    // Dispatch the action to open the modal.
    dispatch(
      handleAddEditModal({
        showAddEdit: !showAddEditModal,
      })
    );

    setAnchorEl(null); // Close the menu
  };

  // A simple handler for closing the menu without taking an action
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // CSV EXPORT FUNCTION
  const handleExportCsv = (event) => {
    event.preventDefault();

    const data = row.invoice_lines;

    // Helper to format values for CSV (Escapes commas/quotes)
    const escapeCsvValue = (val) => {
      if (val === null || val === undefined) return "";
      const stringVal = String(val);
      if (stringVal.search(/("|,|\n)/g) >= 0) {
        return `"${stringVal.replace(/"/g, '""')}"`;
      }
      return stringVal;
    };

    const csvRows = [];

    // SUMMARY SECTION (The Parent Row Data)

    // Specific rows for the top of the file
    const summaryData = [
      ["Document Summary"], // Title
      ["Ref. Number", row.invoice_number ? row.invoice_number : ""],
      ["Union Name", row.to?.company_name ? row.to?.company_name : ""],
      ["Supplier Name", row.from?.company_name ? row.from?.company_name : ""],
      [
        "Date",
        row.invoice_date ? moment(row.invoice_date).format("DD/MM/YYYY") : "",
      ],
      [
        "Total Amount",
        row.amount?.total_including_vat_tax_discounts
          ? `${parseFloat(row.amount.total_including_vat_tax_discounts).toFixed(
              2
            )}`
          : "",
      ],
      ["Status", row.status ? row.status : ""],
      ["Reason", row.remarks ? row.remarks : ""],
      [], // Empty row for spacing
    ];

    // Push summary rows to CSV
    summaryData.forEach((infoRow) => {
      // join with comma, escaping values
      csvRows.push(infoRow.map(escapeCsvValue).join(","));
    });

    // PART B: LINE ITEMS SECTION

    if (!data || !data.length) {
      // If no lines, we still download the summary, just warn locally
    } else {
      // Configuration for Line Items
      // Define the specific columns you want, their order, and their custom header names.
      // Any key from the data NOT listed here will be excluded.
      const columnsToExport = [
        { key: "line_number", header: "Line #" },
        { key: "product_name", header: "Product Description" },
        { key: "product", header: "Product Code" },
        { key: "supplier_product_code", header: "Supplier Code" },
        { key: "quantity", header: "Qty" },
        { key: "unit_price", header: "Unit Price" },
        { key: "line_vat_code", header: "VAT % / VAT Code" },
        { key: "vat_value", header: "VAT Value" },
        { key: "line_total", header: "Line Total" },
      ];

      // Add Header Row for Line Items
      const headerRow = columnsToExport
        .map((col) => escapeCsvValue(col.header))
        .join(",");
      csvRows.push(headerRow);

      // Add Data Rows
      for (const rowItem of data) {
        const values = columnsToExport.map((col) => {
          const val = rowItem[col.key];
          return escapeCsvValue(val);
        });
        csvRows.push(values.join(","));
      }
    }

    // Combine all rows with new lines
    const csvString = csvRows.join("\n");

    // Trigger Download
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = window.document.createElement("a");

    link.href = url;
    // Name the file: Invoice_12345_Lines.csv
    link.setAttribute(
      "download",
      `ref_${row.invoice_number || "export"}_Items.csv`
    );

    window.document.body.appendChild(link);
    link.click();

    // Cleanup
    window.document.body.removeChild(link);
    setAnchorEl(null);
  };

  return (
    <>
      {/* <Box sx={ {display: "flex", flexDirection: "columns", alignItems: "top", justifyContent: "flex-start", textAlign: "center", width: "100%", gap: "10px" } }>
        <Box >
          {row.status === "FAIL" ? (
            <EditIcon sx={{ fontSize: "14px", lineheight: "14px", cursor: "pointer", background: "#555", padding: "8px", color: "#fff", borderRadius: "50%"}} onClick={handleOpenModal}></EditIcon>
          ) : (
            <VisibilityIcon sx={{ fontSize: "14px", lineheight: "14px", cursor: "pointer", background: "#555", padding: "8px", color: "#fff", borderRadius: "50%"}} onClick={handleOpenModal}>View</VisibilityIcon>
          )}
        </Box>
        <DownloadIcon sx={{ fontSize: "14px", lineheight: "14px", cursor: "pointer", background: "#555", padding: "8px", color: "#fff", borderRadius: "50%"}} title={"Export to Excel"} onClick={handleExportCsv} />
      </Box> */}

      <IconButton
        aria-label="more"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        id={row.id + 1}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id={row.id}
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        className="actionMenuBx"
      >
        {row.status === "FAIL" ? (
          <MenuItem onClick={handleOpenModal}>Edit</MenuItem>
        ) : (
          <MenuItem onClick={handleOpenModal}>View</MenuItem>
        )}
        <MenuItem onClick={handleExportCsv}>Export to Excel</MenuItem>
      </Menu>
    </>
  );
};
function DocumentProcessing() {
  // eslint-disable-next-line max-len
  const {
    docpro_invoice_number,
    docpro_creditnote_number,
    docpro_supplier,
    docpro_date_from,
    docpro_date_to,
    docpro_status,
    // supplier_invoice_name,
    supplier_invoice_member,
    supplier_invoice_distribution_channel,
    // fromDate,
    // toDate,
    // invoice_summary_closed,
    // invoice_summary_system_disputed,
    // invoice_summary_user_disputed,
    // invoice_summary_statement,
    // invoice_summary_collected,
    // invoice_summary_paid_to_supplier,
    supplier_invoice_member_account,
    // addProductwarning,
    showAddEditModal,
    showUserDisputeModal,
    release_system_dispute,
    releaseSysDispute,
    // sma_container,
    handleUploadInvoiceModal,
    invoiceEndDate,
    reprocessIds,
  } = useSelector((state) => {
    return {
      docpro_invoice_number: state.externalFilter.docpro_invoice_number,
      docpro_creditnote_number: state.externalFilter.docpro_creditnote_number,
      docpro_supplier: state.externalFilter.docpro_supplier,
      docpro_date_from: state.externalFilter.docpro_date_from,
      docpro_date_to: state.externalFilter.docpro_date_to,
      docpro_status: state.externalFilter.docpro_status,
      supplier_invoice_name: state.externalFilter.supplier_invoice_name,
      supplier_invoice_member: state.externalFilter.supplier_invoice_member,
      supplier_invoice_distribution_channel:
        state.externalFilter.supplier_invoice_distribution_channel,
      invoice_summary_supplier: state.externalFilter.invoice_summary_supplier,
      supplier_invoice_member_account:
        state.externalFilter.supplier_invoice_member_account,
      fromDate: state.externalFilter.from_date,
      toDate: state.externalFilter.to_date,
      invoice_summary_closed: state.externalFilter.invoice_summary_closed,
      invoice_summary_system_disputed:
        state.externalFilter.invoice_summary_system_disputed,
      invoice_summary_user_disputed:
        state.externalFilter.invoice_summary_user_disputed,
      invoice_summary_statement: state.externalFilter.invoice_summary_statement,
      invoice_summary_collected: state.externalFilter.invoice_summary_collected,
      invoice_summary_paid_to_supplier:
        state.externalFilter.invoice_summary_paid_to_supplier,
      addProductwarning: state.modalActions.closeWaringAddProduct,
      showAddEditModal: state.modalActions.hideAddEditModal,
      showUserDisputeModal: state.modalActions.hideUserDisputeModal,
      releaseSysDispute: state.modalActions.releaseSystemDispute,
      release_system_dispute: state.invoiceDisputes,
      sma_container: state.smas,
      handleUploadInvoiceModal: state.modalActions.handleUploadInvoice,
      invoiceEndDate: state.externalFilter.invoiceEndDate,
      reprocessIds: state.invoiceReprocess.reprocessIds,

      // releaseUserDisputeModal
    };
  });

  const [state, setState] = useState({
    invoice_summary_closed: null,
    invoice_summary_system_disputed: null,
    invoice_summary_user_disputed: null,
    invoice_summary_statement: null,
    invoice_summary_collected: false,
    invoice_summary_paid_to_supplier: false,
    pageLoader: false,
    openinvoiceSummarysModal: false,
    memberAccountEndpoint: "",
    selectMemberflag: true,
    supplierMemberDasboadModal: false,
    handleSupplierMemberModal: "",
    selectMemberstatus: "Please Select Member First",
    invoiceIdList: [],
    defaultGrid: {
      pagetitle: "Dcoument Process",
      exportExcelButton: true,
      addEditButton: true,
      apiUrl: "/invoice/",
      searchUrl: "/invoice/filter",
    },
  });

  const statusTypes = [
    { text: "All", value: "all" },
    { text: "Pass", value: "pass" },
    { text: "Fail", value: "fail" },
    { text: "Rejected", value: "rejected" },
    { text: "Archived", value: "archived" },
  ];

  const [documentsProcessedPass, setDocumentsProcessedPass] = useState(1);
  const [documentsProcessedFail, setDocumentsProcessedFail] = useState(1);
  const [documentsProcessedRejected, setDocumentsProcessedRejected] =
    useState(1);
  const [documentsProcessedArchived, setDocumentsProcessedArchived] =
    useState(1);
  const [totalProcessedAmount, setTotalProcessedAmount] = useState(100);

  const [snackBar, setSnackBar] = useState({
    text: "",
    type: "",
    show: false,
  });

  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const uname = accounts[0] && accounts[0].name;

  const columns = [
    {
      headerName: "Ref. Number",
      field: "invoice_number",
      minWidth: 140,
    },
    {
      headerName: "Union Name",
      field: "union_name",
      minWidth: 160,
      valueGetter: (params) => params.row.to.company_name,
      valueFormatter: (params) => {
        const companyName = params.value;
        if (companyName === null || companyName === "") {
          return "";
        }
        return companyName;
      },
    },
    {
      headerName: "Supplier Name",
      field: "supplier_name",
      minWidth: 200,
      valueGetter: (params) => params.row.from.company_name,
      valueFormatter: (params) => {
        const companyName = params.value;
        if (companyName === null || companyName === "") {
          return "";
        }
        return companyName;
      },
    },
    {
      headerName: "Date",
      field: "invoice_date",
      minWidth: 120,
      valueFormatter: (params) => {
        // Check if the value exists before trying to format it
        if (!params.value) {
          return "";
        }
        // Parse the date and then format it into a new string for display
        return moment(params.value).format("DD/MM/YYYY"); // Example format
      },
    },
    {
      headerName: "Amount (£)",
      field: "total_amount",
      width: 120,
      valueGetter: (params) =>
        params.row.amount.total_including_vat_tax_discounts,
      valueFormatter: (params) => {
        const valueAsNumber = parseFloat(params.value);
        if (isNaN(valueAsNumber)) {
          return "";
        }
        return valueAsNumber.toFixed(2);
      },
    },
    {
      headerName: "Status",
      field: "status",
      // renderCell: (params) => (
      //   <Checkbox
      //     checked={params.value === "PASS"}
      //     icon={<CircleIcon />}
      //     checkedIcon={<CheckCircleIcon />}
      //     color="chk_rounded"
      //     size="small"
      //     style={{ pointerEvents: "none" }}
      //   />
      // ),
      headerAlign: "center",
      align: "center",
      minWidth: 110,
    },
    {
      headerName: "Reason",
      field: "remarks",
      minWidth: 240,
      flex: 1,
    },
    {
      headerName: "Action",
      field: "action",
      sortable: false,
      width: 90,
      renderCell: (params) => {
        return <IconMenuLink params={params} />;
      },
    },
  ];

  const handleStartDate = (event) => {
    const sDate = event === null ? null : moment(event, "DD/MM/YYYY");
    dispatch(setDocumentProcessingFromDate(sDate));
  };

  const handleEndDate = (event) => {
    const eDate = event === null ? null : moment(event, "DD/MM/YYYY");
    dispatch(setDocumentProcessingToDate(eDate));
  };

  const handleInvoiceEndDate = (event) => {
    const eDate = event === null ? null : moment(event, "DD/MM/YYYY");
    dispatch(setInvoiceEndDate(eDate));
  };

  const dispatch = useDispatch();

  const [mbacs, setMbAcs] = useState({
    mbac_selected: null,
    mbac_options: [],
  });

  useEffect(() => {
    const fetchMyAPI = async () => {
      if (release_system_dispute.confirmReleaseSystemDispute) {
        try {
          let payLoad = null;
          payLoad = {
            user: uname,
            invoiceId:
              reprocessIds.length > 0 ? reprocessIds : [selected_row.id],
          };
          const { data } = await axiosInvoiceSummaries.post(
            `invoicesummary/releaseSystemDispute`,
            { ...payLoad }
          );
          if (data.success) {
            setState({ ...state, pageLoader: false });
            setSnackBar({
              ...snackBar,
              show: true,
              text: data.message
                ? data.message
                : "Sytem dispute released successfully!",
              type: "success",
            });
            dispatch(
              releaseSystemDisputeStatus({
                key: "confirmReleaseSystemDispute",
                value: false,
              })
            );
            setTimeout(() => {
              // window.location.reload()
              filterBtn();
            }, 2500);
          }
        } catch (error) {
          const {
            response: { data, status },
          } = error;
          if (!data) {
            setSnackBar({
              ...snackBar,
              show: true,
              text: error.message,
              type: "error",
            });
          } else {
            setSnackBar({
              ...snackBar,
              show: true,
              text: data.message,
              type: "error",
            });
          }
          setState({ ...state, pageLoader: false });
        }
      }
    };
    fetchMyAPI();
  }, [release_system_dispute.confirmReleaseSystemDispute]);

  useEffect(() => {
    // This Use Effect is used to clear the Lookups when the page loads.
    dispatch(
      setMemberCode({
        key: "smaSupplierNameOnModal",
        value: "",
      })
    );
    dispatch(
      smaInput({
        key: "sma_supplier_name",
        value: "",
      })
    );
    dispatch(
      setMemberCode({
        key: "smaMemberCodeOnModal",
        value: "",
      })
    );
    dispatch(
      smaInput({
        key: "sma_member_name",
        value: "",
      })
    );
  }, []);

  // useEffect(() => {
  //     const invoiceIds = reprocessIds.map((ele) => {
  //         return ele.invoiceId
  //     })
  //     setState({ ...state, invoiceIdList: invoiceIds })

  // }, [reprocessIds])

  const handleFilterInput2 = (e) => {
    const { value, name } = e.target;
    dispatch(
      setFilter({
        key: name,
        value: value ? value : "",
      })
    );
  };

  const handleFilterInput = (value, id) => {
    //setState({ ...state, [id]: value });
    dispatch(
      setFilter({
        key: id,
        value: value ? value : "",
      })
    );

    if (value !== null) {
      if (id === "supplier_invoice_member") {
        if (value.id) {
          axiosMember
            .get(`members/${value.id}/memberAccounts`)
            .then(function (response) {
              // handle success
              const { status, data } = response;
              if (data) {
                const unique = data;
                setMbAcs({ ...mbacs, mbac_options: unique });
                if (unique.length > 0) {
                  state.memberAccountEndpoint =
                    "members/" + value.id + "/memberAccounts";
                  state.selectMemberflag = false;
                } else {
                  state.selectMemberstatus =
                    "No Member Account present for this Member";
                  state.selectMemberflag = true;
                }
              }
            })
            .catch(function (error) {
              // handle error
              console.log(error);
            });
        }
      }
    }
    if (id === "supplier_invoice_member" && value !== null) {
      setState({ ...state, selectMemberflag: false });
    } else {
      if (id === "supplier_invoice_member") {
        setState({ ...state, selectMemberflag: true });
        setMbAcs({ ...mbacs, mbac_selected: null });
      }
    }
  };

  const handleFilterTextInput = (value, id) => {
    //setState({ ...state, [id]: value });
    dispatch(
      setFilter({
        key: id,
        value: value ? value : value.name ? value.name : "",
      })
    );
  };

  const handleChange = (checked, name) => {
    setState({ ...state, [name]: checked });
    dispatch(
      setFilter({
        key: name,
        value: checked,
      })
    );
  };

  const selectedAutoComplete = (value, id) => {
    dispatch(
      setFilter({
        key: id,
        value: value ? value : "",
      })
    );
    // if (id === 'supplier_invoice_member' && value) {
    //     setState({ ...state, selectMemberflag: false })
    // } else {
    //     if(id === 'supplier_invoice_member') {
    //         setTimeout(() => {
    //             setMbAcs({ ...mbacs, mbac_selected: null })
    //         }, 100);
    //         setState({ ...state, selectMemberflag: true })
    //     }
    // }
  };

  const filterBtn = () => {
    dispatch(resetDataGrid());
    var dynamicFilterObjects = {};

    if (docpro_invoice_number !== "" && docpro_invoice_number !== null) {
      dynamicFilterObjects = {
        ...dynamicFilterObjects,
        invoice_number: docpro_invoice_number,
      };
    }
    if (docpro_creditnote_number !== "" && docpro_creditnote_number !== null) {
      dynamicFilterObjects = {
        ...dynamicFilterObjects,
        order_number: docpro_creditnote_number,
      };
    }

    if (docpro_supplier !== "" && docpro_supplier !== null) {
      dynamicFilterObjects = {
        ...dynamicFilterObjects,
        supplier: docpro_supplier.id,
        // supplier_name: docpro_supplier.name,
      };
    }

    if (
      supplier_invoice_distribution_channel !== "" &&
      supplier_invoice_distribution_channel !== null
    ) {
      dynamicFilterObjects = {
        ...dynamicFilterObjects,
        distributionChannelid: supplier_invoice_distribution_channel.id,
      };
    }

    if (supplier_invoice_member !== "" && supplier_invoice_member !== null) {
      dynamicFilterObjects = {
        ...dynamicFilterObjects,
        member: supplier_invoice_member.name,
      };

      if (mbacs.mbac_selected !== "" && mbacs.mbac_selected !== null) {
        dynamicFilterObjects = {
          ...dynamicFilterObjects,
          memberAccountName: mbacs.mbac_selected.name,
        };
      }
    }

    if (docpro_date_from !== "" && docpro_date_from !== null) {
      dynamicFilterObjects = {
        ...dynamicFilterObjects,
        start_date: moment(docpro_date_from).format("DD/MM/YYYY"),
      };
    }

    if (docpro_date_to !== "" && docpro_date_to !== null) {
      dynamicFilterObjects = {
        ...dynamicFilterObjects,
        end_date: moment(docpro_date_to).format("DD/MM/YYYY"),
      };
    }

    if (docpro_status !== "" && docpro_status !== null) {
      dynamicFilterObjects = {
        ...dynamicFilterObjects,
        status: docpro_status,
      };
    }

    dynamicFilterObjects = {
      ...dynamicFilterObjects,
      // appearedOnStatmnt: invoice_summary_statement,
      // closed: invoice_summary_closed,
      // collectedFromMember: invoice_summary_collected,
      // paidToSupplier: invoice_summary_paid_to_supplier,
      // systemDisputed: invoice_summary_system_disputed,
      // userDisputed: invoice_summary_user_disputed,
      // "brandId": 0,
      // "brandOwnerId": 0,
      // "productId": 0,
      // "supplierMemberAccountCode": "string",
      // "supplierProductCode": "string",
    };

    if (
      (docpro_date_from !== "" &&
        docpro_date_from !== null &&
        moment(docpro_date_from).format("DD/MM/YYYY") === "Invalid date") ||
      (docpro_date_to !== "" &&
        docpro_date_to !== null &&
        moment(docpro_date_to).format("DD/MM/YYYY") === "Invalid date") ||
      (invoiceEndDate !== "" &&
        invoiceEndDate !== null &&
        moment(invoiceEndDate).format("DD/MM/YYYY") === "Invalid date")
    ) {
      setSnackBar({
        ...snackBar,
        show: true,
        text: "Enter date in valid format DD/MM/YYYY and try again!",
        type: "error",
      });
    } else {
      dispatch(
        applyFilter({
          key: "filterList",
          value: dynamicFilterObjects,
        })
      );

      dispatch(filterFlagChange(true));
      dispatch(filterResetFlagChange(false));
      dispatch(setRowPage({ pageData: 10 }));
      dispatch(setPageNo({ page: 1 }));
    }
  };
  const resetFilter = () => {
    if (
      (docpro_invoice_number ||
        docpro_creditnote_number ||
        supplier_invoice_member ||
        supplier_invoice_distribution_channel ||
        supplier_invoice_member_account ||
        docpro_date_from ||
        docpro_date_to ||
        docpro_status) !== ""
    ) {
      dispatch(resetExternalFilter());
      dispatch(resetDataGrid());
    }
    setState({
      ...state,
      invoice_summary_closed: null,
      invoice_summary_system_disputed: null,
      invoice_summary_user_disputed: null,
      invoice_summary_statement: null,
      invoice_summary_collected: false,
      invoice_summary_paid_to_supplier: false,
      selectMemberflag: true,
      selectMemberstatus: "Please Select Member First",
    });
    setMbAcs({ ...mbacs, mbac_selected: null });
    dispatch(filterResetFlagChange(true));
    dispatch(
      setMemberCode({
        key: "smaSupplierNameOnModal",
        value: "",
      })
    );
    dispatch(
      smaInput({
        key: "sma_supplier_name",
        value: "",
      })
    );
    dispatch(
      setMemberCode({
        key: "smaMemberCodeOnModal",
        value: "",
      })
    );
    dispatch(
      smaInput({
        key: "sma_member_name",
        value: "",
      })
    );
    dispatch(
      setFilter({
        key: "invoice_summary_collected",
        value: null,
      })
    );
    dispatch(
      setFilter({
        key: "invoice_summary_paid_to_supplier",
        value: null,
      })
    );
  };

  const hideInvoiceSummaryModal = (event, reason) => {
    // Clear document data and validation errors when modal is closed
    dispatch(clearDocument());
    dispatch(clearValidationErrors());
    setState({ ...state, openinvoiceSummarysModal: false });
    // Close the modal
    dispatch(
      handleAddEditModal({
        showAddEdit: false,
      })
    );
    filterBtn();
  };

  const userDisputeModal = (event, reason) => {
    // setState({ ...state, openinvoiceSummarysModal: false })
  };

  const resetLookups = (params, event) => {
    if (event === "supplier") {
      dispatch(
        setMemberCode({
          key: "smaSupplierNameOnModal",
          value: "",
        })
      );
      dispatch(
        smaInput({
          key: "sma_supplier_name",
          value: "",
        })
      );
      dispatch(
        setFilter({
          key: "docpro_supplier",
          value: null,
        })
      );
    }
    if (event === "members") {
      dispatch(
        setMemberCode({
          key: "smaMemberCodeOnModal",
          value: "",
        })
      );
      dispatch(
        smaInput({
          key: "sma_member_name",
          value: "",
        })
      );
      setMbAcs({ ...mbacs, mbac_options: [], mbac_selected: null });
      setState({ ...state, selectMemberflag: true });
      dispatch(
        setFilter({
          key: "supplier_invoice_member",
          value: null,
        })
      );
    }
  };

  const CommonPopUpModal = (e, type) => {
    setState({
      ...state,
      supplierMemberDasboadModal: true,
      handleSupplierMemberModal: type,
    });
  };

  const hidePriceModal = (event, reason, type) => {
    if (type === "supplier") {
      if (reason) {
        dispatch(
          setFilter({
            key: "supplier_invoice_name",
            value: reason ? { id: reason.id, name: reason.name } : null,
          })
        );
      }
      setState({
        ...state,
        supplierMemberDasboadModal: event === false ? event : true,
      });
    }
    if (type === "members") {
      if (reason) {
        dispatch(
          setFilter({
            key: "supplier_invoice_member",
            value: reason
              ? { id: reason.id, name: reason.name, active: reason.active }
              : null,
          })
        );

        axiosMember
          .get(`members/${reason.id}/memberAccounts`)
          .then(function (response) {
            // handle success
            const { status, data } = response;
            if (data) {
              const unique = data;
              setMbAcs({ ...mbacs, mbac_options: unique });
              if (unique.length > 0) {
                state.memberAccountEndpoint =
                  "members/" + reason.id + "/memberAccounts";
                //state.selectMemberflag = false;
                setState({
                  ...state,
                  selectMemberflag: false,
                  supplierMemberDasboadModal: event === false ? event : true,
                });
              } else {
                //state.selectMemberstatus = 'No Member Account present for this Member'
                setState({
                  ...state,
                  selectMemberflag: true,
                  selectMemberstatus:
                    "No Member Account present for this Member",
                  supplierMemberDasboadModal: event === false ? event : true,
                });
              }
            }
          })
          .catch(function (error) {
            // handle error
            console.log(error);
            setState({
              ...state,
              supplierMemberDasboadModal: event === false ? event : true,
            });
          });
      } else {
        setState({
          ...state,
          supplierMemberDasboadModal: event === false ? event : true,
        });
      }
    }
  };
  const uploadInvoice = () => {
    dispatch(
      handleModalState({
        key: "handleUploadInvoice",
        value: true,
      })
    );
  };

  const handleSetUserDisputes = () => {
    if (reprocessIds.length > 0) {
      disputeflag = "setuserdispute";
      dispatch(
        handleUserDisputeModal({
          showAddEditUserDispute: !showUserDisputeModal,
        })
      );
    } else {
      setSnackBar({
        ...snackBar,
        show: true,
        text: "Please select invoice...!",
        type: "error",
      });
    }
  };

  const handleReleaseUserDisputes = () => {
    if (reprocessIds.length > 0) {
      disputeflag = "releaseuserdispute";
      dispatch(
        handleUserDisputeModal({
          showAddEditUserDispute: !showUserDisputeModal,
        })
      );
    } else {
      setSnackBar({
        ...snackBar,
        show: true,
        text: "Please select invoice...!",
        type: "error",
      });
    }
  };

  const handleReleaseSystemDisputes = () => {
    if (reprocessIds.length > 0) {
      dispatch(
        releaseSystemDisputeStatus({
          key: "startReleaseSystemDispute",
          value: true,
        })
      );
      dispatch(
        releaseSystemDisputeModal({
          releasesystemdispute: !releaseSysDispute,
        })
      );
    } else {
      setSnackBar({
        ...snackBar,
        show: true,
        text: "Please select invoice...!",
        type: "error",
      });
    }
  };
  const onClearAutoComplete = (value, id) => {
    dispatch(
      setFilter({
        key: id,
        value: null,
      })
    );
  };

  useEffect(() => {
    getAllCounts();
  }, []);

  const getAllCounts = async () => {
    try {
      if (localStorage.getItem("dataPass")) {
        setDocumentsProcessedPass(localStorage.getItem("dataPass"));
      }
      if (localStorage.getItem("dataFail")) {
        setDocumentsProcessedFail(localStorage.getItem("dataFail"));
      }
      if (localStorage.getItem("dataRejected")) {
        setDocumentsProcessedRejected(localStorage.getItem("dataRejected"));
      }
      if (localStorage.getItem("dataArchived")) {
        setDocumentsProcessedArchived(localStorage.getItem("dataArchived"));
      }
      if (localStorage.getItem("dataTotalAmount")) {
        setTotalProcessedAmount(localStorage.getItem("dataTotalAmount"));
      }
      setState({ ...state, pageLoader: true });
      const { data } = await axiosDocumentProcessing.get("/invoice/counts");
      if (data) {
        setDocumentsProcessedPass(data.pass);
        setDocumentsProcessedFail(data.fail);
        setDocumentsProcessedRejected(data.rejected);
        setDocumentsProcessedArchived(data.archived);
        setTotalProcessedAmount(data.total_amount);
        localStorage.setItem("dataPass", data.pass);
        localStorage.setItem("dataFail", data.fail);
        localStorage.setItem("dataRejected", data.rejected);
        localStorage.setItem("dataArchived", data.archived);
        localStorage.setItem("dataTotalAmount", data.total_amount);
      }
      setState({ ...state, pageLoader: false });
    } catch (error) {
      // const { response: { data, status } } = error;
      setSnackBar({
        ...snackBar,
        show: true,
        text: "System took long to respond, please retry!",
        type: "error",
      });
      setState({ ...state, pageLoader: false });
    }
  };

  const handleReload = () => {
    filterBtn();
    getAllCounts();
  };

  return (
    <>
      {state.pageLoader && <PageLoader />}
      <Container disableGutters={true} maxWidth={false}>
        <BreadcrumbNavs pageTitle="Document Processing" />
        <Box sx={{ marginBottom: 2.5 }}>
          <TableFilters
            filterFields={
              <>
                <Box component="div">
                  <InputText
                    onChange={handleFilterTextInput}
                    maxWidth={50}
                    label="Ref. Number"
                    id="docpro_invoice_number"
                    size="small"
                  />
                </Box>
                {/* <Box component="div">
                  <InputText
                    onChange={handleFilterTextInput}
                    maxWidth={50}
                    label="Credit Note Number"
                    id="docpro_creditnote_number"
                    size="small"
                  />
                </Box> */}

                <Box component="div">
                  <AutoCompleteStatic
                    endPoint="/supplier/look-up"
                    onChange={handleFilterInput}
                    onSelectedAutoComplete={selectedAutoComplete}
                    onClear={onClearAutoComplete}
                    id="docpro_supplier"
                    label="Supplier Name"
                    name="docpro_supplier"
                  />
                </Box>

                <Box component="div">
                  <FormLabel htmlFor="docpro_date_from" className="fontBold">
                    Date Range (From)
                  </FormLabel>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DesktopDatePicker
                      value={docpro_date_from} //  || moment().startOf('month')
                      onChange={(e) => {
                        handleStartDate(e);
                      }}
                      name="docpro_date_from"
                      label="End Date"
                      inputFormat="DD/MM/YYYY"
                      // eslint-disable-next-line max-len
                      renderInput={({ inputRef, inputProps, InputProps }) => (
                        <Box
                          component="div"
                          sx={{ paddingTop: "6px" }}
                          className="date-picker-input"
                        >
                          <FormControl size="small" sx={{ width: "100%" }}>
                            <TextField
                              size="small"
                              id="from_date"
                              ref={inputRef}
                              {...inputProps}
                              placeholder=""
                              aria-describedby="docpro_date_from_error"
                              autoComplete="off"
                            />
                            <Box className="date-picker-icon">
                              {InputProps?.endAdornment}
                            </Box>
                          </FormControl>
                        </Box>
                      )}
                    />
                  </LocalizationProvider>
                </Box>
                <Box component="div">
                  <FormLabel htmlFor="docpro_date_to" className="fontBold">
                    Date Range (To)
                  </FormLabel>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DesktopDatePicker
                      value={docpro_date_to} //  || moment()
                      onChange={(e) => {
                        handleEndDate(e);
                      }}
                      name="docpro_date_to"
                      label="End Date"
                      inputFormat="DD/MM/YYYY"
                      // eslint-disable-next-line max-len
                      renderInput={({ inputRef, inputProps, InputProps }) => (
                        <Box
                          component="div"
                          sx={{ paddingTop: "6px" }}
                          className="date-picker-input"
                        >
                          <FormControl size="small" sx={{ width: "100%" }}>
                            <TextField
                              size="small"
                              id="to_date"
                              ref={inputRef}
                              {...inputProps}
                              placeholder=""
                              aria-describedby="docpro_date_to_error"
                              autoComplete="off"
                            />
                            <Box className="date-picker-icon">
                              {InputProps?.endAdornment}
                            </Box>
                          </FormControl>
                        </Box>
                      )}
                    />
                  </LocalizationProvider>
                </Box>
                <Box component="div">
                  <FormControl fullWidth>
                    <FormLabel htmlFor="docpro_status">Status</FormLabel>
                    <Select
                      size="small"
                      id="docpro_status"
                      defaultValue=""
                      onChange={handleFilterInput2}
                      value={docpro_status}
                      aria-describedby="msTypeError"
                      name="docpro_status"
                    >
                      {statusTypes.map((option) => (
                        <MenuItem
                          value={option.value}
                          key={option.value}
                          sx={{ fontSize: "0.85rem" }}
                        >
                          {option.text}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                {/* <Box component="div">
                  <SelectDropDown
                    onChange={(e) => handleFilterInput(e)}
                    values={statusTypes}
                    size="small"
                    id="docpro_status"
                    label="Status"
                    name="docpro_status"
                  />
                </Box> */}
              </>
            }
            filterBtns={
              <>
                <Button variant="outlined" onClick={resetFilter}>
                  Reset Filters
                </Button>
                <Button variant="contained" onClick={filterBtn}>
                  Apply
                </Button>
              </>
            }
          ></TableFilters>
        </Box>
        <Grid
          container
          columnSpacing={2}
          sx={{ paddingLeft: "0px", paddingRight: "0px" }}
        >
          <Grid item xs={12} sm={12} md={12} sx={{ marginBottom: 4 }}>
            <Item sx={{ paddingLeft: "0px", paddingRight: "0px" }}>
              <Grid container alignItems="center">
                <Grid item xs={12} md={2.4}>
                  <Item>
                    <Box
                      component="div"
                      sx={{
                        width: "100%",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "10px",
                        margin: "10px 5px",
                      }}
                    >
                      <Grid
                        container
                        alignItems={"center"}
                        sx={{ display: "block", width: "100%" }}
                      >
                        <Grid
                          sx={{ padding: "20px 10px", textAlign: "center" }}
                        >
                          <Item
                            sx={{
                              backgroundColor: "transparent",
                              padding: "0",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "800",
                                fontSize: "34px",
                                color: "#15191E",
                                lineHeight: "50px",
                              }}
                            >
                              {documentsProcessedPass ||
                              documentsProcessedPass === 0 ? (
                                documentsProcessedPass
                              ) : (
                                <CircularProgress color="inherit" />
                              )}
                            </Typography>
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                color: "#15191E",
                                lineHeight: "20px",
                              }}
                            >
                              Pass
                            </Typography>
                          </Item>
                        </Grid>
                      </Grid>
                    </Box>
                  </Item>
                </Grid>
                <Grid item xs={12} md={2.4}>
                  <Item>
                    <Box
                      component="div"
                      sx={{
                        width: "100%",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "10px",
                        margin: "10px 5px",
                      }}
                    >
                      <Grid
                        container
                        alignItems={"center"}
                        sx={{ display: "block", width: "100%" }}
                      >
                        <Grid
                          sx={{ padding: "20px 10px", textAlign: "center" }}
                        >
                          <Item
                            sx={{
                              backgroundColor: "transparent",
                              padding: "0",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "800",
                                fontSize: "34px",
                                color: "#15191E",
                                lineHeight: "50px",
                              }}
                            >
                              {documentsProcessedFail ||
                              documentsProcessedFail === 0 ? (
                                documentsProcessedFail
                              ) : (
                                <CircularProgress color="inherit" />
                              )}
                            </Typography>
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                color: "#15191E",
                                lineHeight: "20px",
                              }}
                            >
                              Fail
                            </Typography>
                          </Item>
                        </Grid>
                      </Grid>
                    </Box>
                  </Item>
                </Grid>
                <Grid item xs={12} md={2.4}>
                  <Item>
                    <Box
                      component="div"
                      sx={{
                        width: "100%",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "10px",
                        margin: "10px 5px",
                      }}
                    >
                      <Grid
                        container
                        alignItems={"center"}
                        sx={{ display: "block", width: "100%" }}
                      >
                        <Grid
                          sx={{ padding: "20px 10px", textAlign: "center" }}
                        >
                          <Item
                            sx={{
                              backgroundColor: "transparent",
                              padding: "0",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "800",
                                fontSize: "34px",
                                color: "#15191E",
                                lineHeight: "50px",
                              }}
                            >
                              {documentsProcessedRejected ||
                              documentsProcessedRejected === 0 ? (
                                documentsProcessedRejected
                              ) : (
                                <CircularProgress color="inherit" />
                              )}
                            </Typography>
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                color: "#15191E",
                                lineHeight: "20px",
                              }}
                            >
                              Rejected
                            </Typography>
                          </Item>
                        </Grid>
                      </Grid>
                    </Box>
                  </Item>
                </Grid>
                <Grid item xs={12} md={2.4}>
                  <Item>
                    <Box
                      component="div"
                      sx={{
                        width: "100%",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "10px",
                        margin: "10px 5px",
                      }}
                    >
                      <Grid
                        container
                        alignItems={"center"}
                        sx={{ display: "block", width: "100%" }}
                      >
                        <Grid
                          sx={{ padding: "20px 10px", textAlign: "center" }}
                        >
                          <Item
                            sx={{
                              backgroundColor: "transparent",
                              padding: "0",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "800",
                                fontSize: "34px",
                                color: "#15191E",
                                lineHeight: "50px",
                              }}
                            >
                              {documentsProcessedArchived ||
                              documentsProcessedArchived === 0 ? (
                                documentsProcessedArchived
                              ) : (
                                <CircularProgress color="inherit" />
                              )}
                            </Typography>
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                color: "#15191E",
                                lineHeight: "20px",
                              }}
                            >
                              Archived
                            </Typography>
                          </Item>
                        </Grid>
                      </Grid>
                    </Box>
                  </Item>
                </Grid>
                <Grid item xs={12} md={2.4}>
                  <Item>
                    <Box
                      component="div"
                      sx={{
                        width: "100%",
                        backgroundColor: "#B253AE",
                        borderRadius: "10px",
                        margin: "10px 5px",
                      }}
                    >
                      <Grid
                        container
                        alignItems={"center"}
                        sx={{ display: "block", width: "100%" }}
                      >
                        <Grid
                          sx={{ padding: "20px 10px", textAlign: "center" }}
                        >
                          <Item
                            sx={{
                              backgroundColor: "transparent",
                              padding: "0",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "800",
                                fontSize: "34px",
                                color: "#ffffff",
                                lineHeight: "50px",
                              }}
                            >
                              {totalProcessedAmount ||
                              totalProcessedAmount === 0 ? (
                                "£ " +
                                parseFloat(totalProcessedAmount).toLocaleString(
                                  "en-GB",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )
                              ) : (
                                <CircularProgress color="inherit" />
                              )}
                            </Typography>
                            <Typography
                              sx={{
                                fontWeight: "600",
                                fontSize: "14px",
                                color: "#ffffff",
                                lineHeight: "20px",
                              }}
                            >
                              Total Processed Amount
                            </Typography>
                          </Item>
                        </Grid>
                      </Grid>
                    </Box>
                  </Item>
                </Grid>
              </Grid>
            </Item>
          </Grid>
        </Grid>
        <Box
          component="div"
          className="exportsButtons"
          sx={{
            columnGap: 1.75,
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: { xs: "center", sm: "end" },
            textAlign: { xs: "center", sm: "end" },
            marginBottom: { xs: 2.5, sm: -3 },
          }}
        >
          <div className="table-actionable">
            <Box
              component={"div"}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                marginRight: "15px",
              }}
              onClick={handleReload}
            >
              <RefreshIcon color="primary"></RefreshIcon>{" "}
              <span style={{ marginLeft: "5px", color: "#B253AE" }}>
                Refresh Data
              </span>
            </Box>
          </div>
          {/* <div className="table-actionable">
            <Button
              variant="contained"
              color="tertiary"
              size="small"
              onClick={handleSetUserDisputes}
            >
              Set User Disputes
            </Button>
          </div> */}

          {/* <div className="table-actionable">
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleReleaseUserDisputes}
            >
              Release User Disputes
            </Button>
          </div> */}

          {/* <div className="table-actionable">
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={handleReleaseSystemDisputes}
            >
              Release System Disputes
            </Button>
          </div> */}

          {/* <div className="table-actionable">
            <Button variant="contained" size="small" onClick={uploadInvoice}>
              Upload Invoice
            </Button>
          </div> */}
        </Box>
        <DataTableDocumentProcessing
          defaultGrid={state.defaultGrid}
          columns={columns}
        ></DataTableDocumentProcessing>
        {showAddEditModal && (
          <EditViewDocumentProcess
            onShow={showAddEditModal}
            size="large_overlay"
            onHide={hideInvoiceSummaryModal}
            // onHide={(e, reason) => hideInvoiceSummaryModal(e, reason)}
          />
        )}
        {/* {showAddEditModal && (
          <InvoiceDetails
            tabs={tabs}
            onShow={showAddEditModal}
            onHide={(e, reason) => hideInvoiceSummaryModal(e, reason)}
          />
        )} */}
        {showUserDisputeModal && (
          <UserDisputeModal
            values={disputeflag}
            onShow={showUserDisputeModal}
            onHide={(e, reason) => userDisputeModal(e, reason)}
            selectedrow={selected_row}
          />
        )}
        {handleUploadInvoiceModal && (
          <UploadInvoiceModal
            size="small_overlay"
            onShow={handleUploadInvoiceModal}
          />
        )}
        {releaseSysDispute && (
          <WarningModal size="small_overlay" onShow={releaseSysDispute} />
        )}
        {snackBar.show && (
          <SnackBarDialog
            onShow={snackBar.show}
            text={snackBar.text}
            type={snackBar.type}
            onHide={(e) => {
              setSnackBar({ ...snackBar, show: e });
            }}
          />
        )}

        {state.supplierMemberDasboadModal && (
          <CommonPopUp
            onShow={state.supplierMemberDasboadModal}
            size="medium_overlay"
            supplierMemberCode={{
              title:
                state.handleSupplierMemberModal &&
                state.handleSupplierMemberModal === "members"
                  ? "Member Details"
                  : "Supplier Details",
              type: state.handleSupplierMemberModal,
            }}
            onHide={(e, reason) =>
              hidePriceModal(e, reason, state.handleSupplierMemberModal)
            }
          />
        )}
      </Container>
    </>
  );
}

export default DocumentProcessing;
